// extracted by mini-css-extract-plugin
export var tableContainer = "fJ_ms";